// extracted by mini-css-extract-plugin
module.exports = {"container":"RejectRequestDialog_container__3XDTg","note":"RejectRequestDialog_note__KRZVm","reason":"RejectRequestDialog_reason__2T9A3"};